import { cn } from "@/lib/utils";

/** Matches poll day/hour pickers — sits flush on the card surface. */
export const homeFieldBase =
  "rounded-lg border border-border bg-card transition active:scale-[0.99]";

export const homeFieldInteractive = cn(homeFieldBase, "hover:bg-muted/40");

/** Inputs and selects inside Home phase cards. */
export const homeInputField = cn(
  homeFieldBase,
  "hover:border-soccer-primary/30 focus-visible:ring-soccer-primary"
);
